import react, { useMemo, useState } from 'react';
import './formularios.scss'
import { IntegracionProyectos } from '../../integracion';
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel';
import Table from '../../../../../components/moleculesv2/Table/Table';
import Card from '../../../../../components/Atomsv2/Card/Card';
import Button from '../../../../../components/Atomsv2/Button/Button';
import Column from '../../../../../components/moleculesv2/Table/Column';
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast';
import Modal from '../../../../../components/Atomsv2/Modal/Modal';
import Input from '../../../../../components/Atomsv2/Input/Input';
import Select from '../../../../../components/Atomsv2/Select/Select';
import Tooltip from '../../../../../components/Atomsv2/Tooltip/Tooltip';

const Area = ({ data, open, onClose, setData }) => {
    const { toasts, addToast, removeToast } = useToast();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [addData, setAddData] = useState({
        area: '',
        descripcion: '',
    });
    // configuracion dela edicion 
    const handleRowEdit = async (newRow, rowIndex) => {
        const dataToUpdate = {
            id: newRow.ID,
            area: newRow.AREA,
            descripcion: newRow.DESCRIPCION,
        }
        try {
            await IntegracionProyectos.updateArea(dataToUpdate);
            setData(prev => ({
                ...prev,
                area: prev.area.map((item, index) => index === rowIndex ? newRow : item)
            }));
            addToast("Operación exitosa", "success", 3000, 'ligth');


        }
        catch (error) {
            console.error("Error al actualizar el área:", error);
            addToast("error en la edición", "error", 3000, 'ligth');
        }
    };

    const submit = async () => {
        try {
            if (!addData.area || !addData.descripcion) {
                addToast("Por favor, complete todos los campos", "error", 3000, 'ligth');
                return;
            }
            await IntegracionProyectos.createArea(addData);
            setData(prev => ({
                ...prev,
                area: [...prev.area, { ID: prev.area.length + 1, AREA: addData.area, DESCRIPCION: addData.descripcion }]
            }));
            setAddData({ area: '', descripcion: '' });
            setOpenAddModal(false);
            addToast("Área agregada exitosamente", "success", 3000, 'ligth');
        }
        catch (error) {
            console.error("Error al agregar el área:", error);
            addToast("Error al agregar el área", "error", 3000, 'ligth');
        }
    }
    //  aqui finaliza la edicion

    return (
        <SidePanel
            open={open}
            onClose={onClose}
            className={'proyecto-area'}
            title="Área"
            icon="crop_square"
            subtitle='Edita o crea un área para organizar tus proyectos'
            width="50vw"
        >
            <div className='header-proyecto-general'>
                <Button icon={"add"} onClick={() => { setOpenAddModal(true) }}></Button>
            </div>
            <Card>
                <Table
                    data={data.area}
                    height='calc(100vh - 270px)'
                    globalFilter
                    onRowEdit={handleRowEdit}
                >
                    <Column
                        header="ID"
                        value="ID"
                    />
                    <Column
                        header="AREA"
                        value="AREA"
                        edit="text"
                    />
                    <Column
                        header="DESCRIPCION"
                        value="DESCRIPCION"
                        edit="text"
                    />
                </Table>
            </Card>
            {
                openAddModal == true && (
                    <Modal style={{ zIndex: "1201" }} onClose={() => setOpenAddModal(false)} title="Agregar Área">
                        <div className='modal-content-general-proyectos'>
                            <div className='input-container'>

                                <Input label={"AREA"} icon={'crop_square'} value={addData.area} onChange={(e) => { setAddData(prev => ({ ...prev, area: prev.area = e.target.value })) }}></Input>
                            </div>
                            <Input label={"DESCRIPCIÓN"} icon={'sticky_note_2'} value={addData.descripcion} onChange={(e) => { setAddData(prev => ({ ...prev, descripcion: prev.descripcion = e.target.value })) }}></Input>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                                <Button icon='save' onClick={() => { submit() }}>Guardar</Button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </SidePanel>
    )
}
export default Area
